import * as flatbuffers from "flatbuffers";

/**
 * Any FlatBuffer Object API type (*T) that supports pack().
 * All generated *T classes (e.g. BatchedFrontEndMessageT, FrontEndMessageT)
 * implement this interface.
 */
interface Packable {
  pack(builder: flatbuffers.Builder): flatbuffers.Offset;
}

/**
 * Pack a FlatBuffer Object API type (*T) into binary bytes.
 * Works with any generated type that has a pack(builder) method.
 *
 * @example
 *   const batch = new BatchedFrontEndMessageT(BigInt(Date.now()), messages);
 *   const bytes = packToBytes(batch);
 */
export function packToBytes<T extends Packable>(obj: T): Uint8Array {
  const builder = new flatbuffers.Builder(1024);
  const offset = obj.pack(builder);
  builder.finish(offset);
  return builder.asUint8Array();
}

/**
 * Send a FlatBuffer binary payload to an API endpoint.
 * Uses `application/flatbuffers` content type so the server knows
 * to decode the body as a FlatBuffer rather than JSON.
 */
export async function sendFlatBufferBinary(
  url: string,
  payload: Uint8Array,
  token: string,
  method: "PUT" | "POST" = "PUT",
): Promise<Response> {
  return fetch(url, {
    method,
    headers: {
      "Content-Type": "application/flatbuffers",
      Authorization: token,
    },
    // Send the exact byte range — payload may be a view into a larger
    // ArrayBuffer (FlatBuffers.Builder reuses a single buffer), so
    // payload.buffer would include extra bytes and produce invalid data.
    body: payload.slice().buffer,
  });
}

/**
 * Fetch a FlatBuffer binary response from an API endpoint.
 * Sets `Accept: application/flatbuffers` so the server returns binary
 * instead of JSON. Returns the raw bytes for client-side UnPack().
 */
export async function fetchFlatBufferBinary(
  url: string,
  token: string,
): Promise<Uint8Array | null> {
  const response = await fetch(url, {
    headers: {
      Accept: "application/flatbuffers",
      Authorization: token,
    },
  });
  if (!response.ok) return null;
  const buffer = await response.arrayBuffer();
  return new Uint8Array(buffer);
}
